module.exports = __webpack_public_path__ + "img/tuanduixietong.222061fe.png";